import React from 'react'
import styled from '@emotion/styled'
import { Banner } from 'src/components/molecules/Banner'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'

export const TopBanner = () => {
  return (
    <TopBannerView
      text="メンテナンスに伴い、【2024年3月28日(木) AM 0:00～2:00】は弊社サービスサイトをご覧いただくことができません。"
      link=""
    />
  )
}

const TopBannerView = styled(Banner)`
  padding: 0 20px;
  box-sizing: border-box;
  @media screen and (max-width: ${BreakPoint.TABLET}) {
    height: 100%;
  }
`
